import Select from '../ui/Select'
import TagFilter from './TagFilter'
import { classNames } from '../../lib/classNames'

const TABS = [
    ['all', 'All'],
    ['pinned', 'Pinned'],
    ['archived', 'Archived'],
]

const SORTS = [
    ['updated', 'Updated'],
    ['created', 'Created'],
    ['title', 'Title'],
]

export default function NoteFilterBar({ tab, onTabChange, sortKey, onSortChange, allTags, activeTags, onToggleTag }) {
    return (
        <div className="mt-3">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex gap-2 overflow-auto">
                    {TABS.map(([key, label]) => (
                        <button
                            key={key}
                            onClick={() => onTabChange(key)}
                            className={classNames(
                                'px-3 py-1.5 border-2 text-sm font-semibold uppercase tracking-wide transition-colors',
                                tab === key
                                    ? 'bg-black text-white border-black dark:bg-white dark:text-black dark:border-white'
                                    : 'bg-white text-black border-black dark:bg-zinc-950 dark:text-white dark:border-white hover:bg-accent hover:text-black hover:border-accent'
                            )}
                        >
                            {label}
                        </button>
                    ))}
                </div>
                <div className="flex items-center gap-2">
                    <span className="text-xs uppercase text-zinc-500">Sort</span>
                    <Select value={sortKey} onChange={(e) => onSortChange(e.target.value)} className="w-auto" aria-label="Sort notes by">
                        {SORTS.map(([key, label]) => (
                            <option key={key} value={key}>{label}</option>
                        ))}
                    </Select>
                </div>
            </div>
            <TagFilter allTags={allTags} activeTags={activeTags} onToggle={onToggleTag} />
        </div>
    )
}
